import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouteHelperService } from '../route-helper.service';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';

@Injectable()
export class EnableOnSiteGuard {
  constructor(private readonly routeHelper: RouteHelperService, private readonly tokenStorage: TokenStorageService) {}

  public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const featureFlag = route.data.featureFlag || route.parent.data.featureFlag;
    const userInfo = this.tokenStorage.userInfo;

    if (!userInfo) {
      return false;
    }

    if (userInfo.CurrentSite[featureFlag]) {
      return true;
    }

    this.routeHelper.forbidden();

    return false;
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }
}
